<template>
<div class="chapter">
<div class="inner_page">
<p class="block_18" id="calibre_pb_6"> </p>
<p class="block_19">“I saw an angel in the marble, and I carved until I set him free...”</p>
<p class="block_20">−Michelangelo</p>
<p class="block_21"> </p>
<p class="block_21"> </p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// index_split_005.vue?2e87b4bf